/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import type { OrganizationSummary, ProviderSummary, RegistryAddress } from "../api/registry";

export type RegistryOption = { value: string; label: string };

export const PARTNER_TYPES = [
  "PEDIATRICIAN",
  "FAMILY_PRACTICE",
  "SCHOOL",
  "HEALTH_PLAN",
  "CHANNEL_PARTNER",
  "URGENT_CARE",
  "HOSPITAL",
  "SPECIALIST",
  "OTHER",
] as const;

export function partnerTypeLabel(partnerType: string | null): string {
  if (partnerType === null) {
    return "Unclassified";
  }
  const words = partnerType.toLowerCase().split("_").join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function providerName(first: string | null, last: string | null): string {
  const name = [first, last].filter((part) => part !== null).join(" ");
  return name === "" ? "Unnamed provider" : name;
}

/** Organizations as a picker or filter offers them: the id as the value, the name as the label. */
export function organizationOptions(organizations: OrganizationSummary[]): RegistryOption[] {
  return organizations.map((organization) => ({
    value: String(organization.id),
    label: organization.name,
  }));
}

export function providerOptions(providers: ProviderSummary[]): RegistryOption[] {
  return providers.map((provider) => ({
    value: String(provider.id),
    label: providerName(provider.firstName, provider.lastName),
  }));
}

export function formatAddress(address: RegistryAddress | null): string | null {
  if (address === null) {
    return null;
  }
  const parts = [
    address.line1,
    address.line2,
    [address.city, address.state].filter((part) => part !== null).join(", "),
    address.zip,
  ].filter((part) => part !== null && part !== "");
  return parts.length === 0 ? null : parts.join(", ");
}
